import axios, { AxiosInstance } from 'axios';

// Create axios instance with default config
const apiClient: AxiosInstance = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token and base URL
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('jwt_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add request ID for debugging/tracking
    config.headers['x-request-id'] = `web-${Date.now()}`;

    // If the request data is FormData, remove the default Content-Type header
    // This allows Axios to set the correct multipart/form-data boundary automatically
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    // Get base URL from localStorage or use default
    const baseURL = localStorage.getItem('club_url') || process.env.REACT_APP_API_URL || 'http://localhost:4000';
    config.baseURL = baseURL;

    console.log('[API Client] Request:', config.method?.toUpperCase(), config.url, 'Base URL:', baseURL);
    return config;
  },
  (error) => {
    console.error('[API Client] Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    console.log('[API Client] Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('[API Client] Response error:', error.response?.status, error.config?.url, error.response?.data);
    
    // Handle 401 unauthorized or "not authorized" messages
    const isUnauthorized = error.response?.status === 401 || 
                          error.response?.statusText?.toLowerCase().includes('unauthorized') ||
                          error.response?.data?.message?.toLowerCase().includes('not authorized') ||
                          error.response?.data?.message?.toLowerCase().includes('unauthorized') ||
                          error.response?.data?.error?.toLowerCase().includes('not authorized') ||
                          error.response?.data?.error?.toLowerCase().includes('unauthorized');
    
    if (isUnauthorized) {
      // Skip auto-redirect for certain endpoints
      const skipRedirectEndpoints = ['/verify-token', '/login', '/app-auth'];
      const shouldSkipRedirect = skipRedirectEndpoints.some(endpoint =>
        error.config?.url?.includes(endpoint)
      );
      
      if (shouldSkipRedirect) {
        console.log('[API Client] Skipping redirect for endpoint:', error.config?.url);
        return Promise.reject(error);
      }
      
      console.log('[API Client] Unauthorized - clearing session and redirecting to login');
      
      // Clear all auth-related data from localStorage
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('club_url');
      localStorage.removeItem('club_id');
      localStorage.removeItem('cached_user');
      localStorage.removeItem('user_permissions');
      
      // Clear any session storage as well
      sessionStorage.clear();
      
      // Only redirect if not already on login page
      if (window.location.pathname !== '/login') {
        // Use replace to prevent back button issues
        window.location.replace('/login');
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;